/* eslint-disable no-alert */
import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import _ from 'lodash'
import { Table, Button, Label } from 'semantic-ui-react'

const BoldText = styled.div`
  text-transform: uppercase;
  font-weight: bold;
`

const Price = styled(BoldText)`
  color: rgb(208, 62, 62);
`

export default class CashOutRow extends React.Component {
  state = {
    loading: false,
  }

  onConfirm = requestId => {
    const { confirmCashOut } = this.props

    const confirmation = window.confirm('Are you sure you already sent money to driver?')

    if (confirmation) {
      this.setState({ loading: true }, () => {
        confirmCashOut(requestId, this.onActionComplete)
      })
    }
  }

  onCancel = requestId => {
    const { cancelCashOut } = this.props
    const reason = window.prompt('Reason', '')

    this.setState({ loading: true }, () => {
      cancelCashOut(requestId, reason, this.onActionComplete)
    })
  }

  onActionComplete = error => {
    if (error) {
      alert(error)
    } else {
      alert('Successfully complete the action')
    }
  }

  renderPendingActions = id => {
    const { loading } = this.state

    return (
      <div style={{ width: 156 }}>
        <Button disabled={loading} size="mini" onClick={() => this.onConfirm(id)} style={{ width: 75 }}>
          Confirm
        </Button>
        <Button
          disabled={loading}
          size="mini"
          color="red"
          onClick={() => this.onCancel(id)}
          style={{ width: 75 }}
        >
          Cancel
        </Button>
      </div>
    )
  }

  renderStatus = status => (
    <Label color={status === 'completed' ? 'green' : 'red'} style={{ width: 75 }}>
      {_.capitalize(status)}
    </Label>
  )

  render() {
    const { cashOut } = this.props

    return (
      <Table.Row>
        <Table.Cell style={{ width: 210 }}>{cashOut.id}</Table.Cell>
        <Table.Cell textAlign="center">{cashOut.deliverer_name}</Table.Cell>
        <Table.Cell textAlign="center">{cashOut.deliverer}</Table.Cell>
        <Table.Cell textAlign="center">
          <BoldText>{cashOut.aba_number}</BoldText>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <BoldText>{cashOut.aba_name}</BoldText>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Price>{cashOut.amount}</Price>
        </Table.Cell>
        <Table.Cell textAlign="center">
          {moment(cashOut.created_at).format('DD-MM-YYYY')}
          <br />
          {moment(cashOut.created_at).format('HH:mm a')}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {moment(cashOut.updated_at).format('DD-MM-YYYY')}
          <br />
          {moment(cashOut.updated_at).format('HH:mm a')}
        </Table.Cell>
        <Table.Cell textAlign="center">
          {cashOut.status === 'pending'
            ? this.renderPendingActions(cashOut.id)
            : this.renderStatus(cashOut.status)}
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/cashOuts/components/CashOutRow.js